import React from 'react'
import SAPIntro from './SAPIntro'
import SAPConsultants from './SAPConsultants'
import SAPWhyChooseUs from './SAPWhyChooseUs'
import SAPStaffAugmentation from './SAPStaffAug'

import SAPOurServoceBenifits from './SAPBenifits'
import ContactForm from './SAPContact'
import SAPAMS from './SAPAMS'
import { useRef } from 'react'
const SAP = () => {

    const contact=useRef(null)
  return (
    <div>
          <section>
              <SAPIntro contact={ contact} />
          </section>


          <section>
              <SAPStaffAugmentation />
          </section>

          
          <section>
              <SAPConsultants/>
          </section>

          
          <section>
              <SAPAMS/>
          </section>

          
         
          



          <section>
              <SAPWhyChooseUs contact={ contact}/>
          </section>
           
          <section>
              <SAPOurServoceBenifits/>
          </section>
          

         
          <section>
              <ContactForm ref={contact} />
          </section>

{/* <div class="hs-form-frame" data-region="na2" data-form-id="37611edb-5b9d-4515-9003-cab18f280e08" data-portal-id="242790435"></div> */}
    </div>
  )
}

export default SAP
